

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface patientoptimizationParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface patientoptimization {
        REG_ID:any,
        reG_DATE?:Date,
        reG_NUM?:number,
        firstname:string,
        lastname:string,
        mobile:string,
        gender:string,
        dob:Date,
        age:number,
        bloodgroup:string,
        random_sugar:any,
        Pre_sugar:any,
        Post_sugar:any,
        weight:any,
        height:any,
        BP_Sys:any,
        BP_Dia:number,
        bp_date:Date,
        Pulse:any,
        pulse_date:Date,
        Temp:any,
        temp_date:Date,
        Heart_Rate:any,
        heart_date:Date,
        Resp_Rate:any,
        resp_date:Date,
        last_visit_date:Date,

    parameters?: patientoptimizationParameter[];
    links?: any;
}



export abstract class patientoptimizationData {
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<patientoptimization[]>;
    abstract create(url: string, data: patientoptimization): Observable<patientoptimization[]>;
    abstract update(url: string, data: patientoptimization): Observable<patientoptimization>;
    abstract delete(url: string): Observable<any>;
}
